<app-page-content header="You’re all set.">
  <ng-template #subtitle>
    <p class="text-4">
      We got your message and will be in touch within one business day.
    </p>
    <a routerLink="/">Back to home</a>
  </ng-template>

  <img
    ngSrc="contact-success/mail-sent.svg"
    height="345"
    width="385"
    style="max-width: min(385px, calc(100% - 5rem)); margin-inline: auto"
  />
</app-page-content>
